import { render, staticRenderFns } from "./EditProjectOneTarget.vue?vue&type=template&id=85391280&scoped=true"
import script from "./EditProjectOneTarget.vue?vue&type=script&lang=js"
export * from "./EditProjectOneTarget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85391280",
  null
  
)

export default component.exports